import clsx from 'clsx';
import { without } from 'ramda';
import * as React from 'react';
import { P1 } from 'src/components/Typography';
import { UseIcon } from 'src/components/UseIcon';
import { FormParserContext } from 'src/contexts/form.context';
import { ButtonBaseType, ID } from 'src/models';
import { render } from 'src/tools/render.tools';

import styles from './LargeSelect.module.scss';

export function LargeSelect() {
  const { value, script, onChange } = React.useContext(FormParserContext);

  const [localValue, setLocalValue] = React.useState(value);

  // support csv format for values, instead of array of value
  React.useEffect(() => {
    if (value && script.multiSelect && script.type === 'csv') setLocalValue(value.split(','));
    else setLocalValue(value);
  }, [value, script]);

  function handleOnChange(v: ID | ID[]) {
    if (script.multiSelect && script.type === 'csv' && Array.isArray(v)) onChange(v.join(','));
    else onChange(v);
  }

  function handleOnClick(id: ID) {
    return function call(e: React.MouseEvent<HTMLButtonElement>) {
      e.preventDefault();

      if (script.multiSelect) {
        if (!localValue || !localValue.length) handleOnChange([id]);
        else if (localValue && localValue.length) {
          if (localValue.includes(id)) handleOnChange(without([id], localValue));
          else handleOnChange([...localValue, id]);
        }
      } else if (!script.multiSelect && id !== localValue) handleOnChange(id);
    };
  }

  function getIsSelected(id: ID) {
    if (script.multiSelect && localValue) return localValue.includes(id);

    return localValue === id;
  }

  function renderButton(item: ButtonBaseType) {
    const isSelected = getIsSelected(item.id);

    return (
      <button
        key={item.id}
        className={clsx(styles.button, 'row nowrap a-center', {
          [styles.selected]: isSelected,
          [styles.regular]: !isSelected,
        })}
        onClick={handleOnClick(item.id)}
      >
        <UseIcon iconId={item.iconId ?? 'add'} className={styles.icon} />
        <P1 className={styles.label}>{item.label}</P1>
      </button>
    );
  }

  return <div className={clsx(styles.container, 'row wrap j-between')}>{render(script.items ?? [], renderButton)}</div>;
}
